module.exports = __webpack_public_path__ + "0a45a9a336d90814700517d3b632ae05.MP3";